if (!customElements.get('pv-ingredient-explorer')) {
  customElements.define('pv-ingredient-explorer', class extends HTMLElement {
    static activeIngredients = new Map();
    connectedCallback() {
      if (this.events) return;
      this.tabs = [...this.querySelectorAll('[data-pv-tab]')];
      this.panels = [...this.querySelectorAll('[data-pv-panel]')];
      if (this.tabs.length < 2) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const tablist = this.querySelector('.pv-explorer__tabs');
      tablist.setAttribute('role', 'tablist');
      const desktop = window.matchMedia('(min-width: 990px)');
      const setOrientation = () => tablist.setAttribute('aria-orientation', desktop.matches ? 'vertical' : 'horizontal');
      desktop.addEventListener('change', setOrientation, options);
      setOrientation();
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].setAttribute('tabindex', '0');
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus({ preventScroll: true });
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-pv-panel]');
        const index = this.panels.indexOf(panel);
        if (index !== -1) this.select(index);
      }, options);
      // Preserve the selected ingredient when Shopify replaces this section after an edit.
      const active = this.constructor.activeIngredients.get(this.id);
      const activeIndex = this.tabs.findIndex(tab => tab.dataset.pvTab === active);
      this.select(activeIndex > 0 ? activeIndex : 0);
      tablist.hidden = false;
      this.classList.add('is-enhanced');
    }
    select(index) {
      if (window.Shopify?.designMode) this.constructor.activeIngredients.set(this.id, this.tabs[index].dataset.pvTab);
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}

// A formula block belongs to one product; help the merchant switch preview context.
if (window.Shopify?.designMode && !window.pvFormulaEditorBound) {
  window.pvFormulaEditorBound = true;
  document.addEventListener('shopify:block:select', event => {
    document.querySelectorAll('[data-pv-formula-notice]').forEach(notice => { notice.hidden = true; });
    const notice = event.target.closest('[data-pv-formula-notice]');
    if (notice) {
      notice.hidden = false;
      notice.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });
  document.addEventListener('shopify:block:deselect', event => {
    const notice = event.target.closest('[data-pv-formula-notice]');
    if (notice) notice.hidden = true;
  });
}
